// The hero image can be added to the src folder with the HeroImage.png name.
// Logo image can be added to the src folder as Logo.png
// Favicon image can be added to the public folder as favicon.ico

// Project specific values that can be changed easily.
export const projectConfiguration = {
  // Product Key
  productKey: "facesaber",

  // Content variables
  heroLineOne: "EMBRACE THE JOY OF",
  heroLineTwo: "GIFTING MUSIC",
  heroLineThree: "",
  subtitle:
    "Share a soulful soundtrack that transcends time with your friends and unleash the power of personalized musical journeys.",

  // Colors
  backgroundColor: "#0F1118",
  primaryTextColor: "#ffffff",
  secondaryTextColor: "#E5E5E5",
  tertiaryTextColor: "#E5E5E5",
  inputBackgroundColor: "#595D6F",
  inputFocusBackgroundColor: "#ffffff",
  inputTextColor: "#595D6F",
  inputFocusTextColor: "#0D0F14",
  punchColor: "#F504F5", // Used as link color
  footerLinkColor: "#ffffff",
  buttonTextColor: "#ffffff",

  //   Fonts
  primaryFont: "Koulen",
  secondaryFont: "Inter",
};
